import { buildFormAnswersSchema, type FormFieldDto } from '@napaicp/schemas'

/**
 * AC-366: a registration row's existence means "submitted", but the form can
 * change afterwards (a required field is added, a required checkbox was saved
 * unchecked). Answers that no longer satisfy the *current* published form are
 * "needs update": returns the fields (in form order) the saved answers fail,
 * empty when they satisfy it. Validation is the same schema the server applies
 * on every save, so what is flagged here is exactly what a save would reject.
 */
export function findIncompleteRegistrationFields(
  fields: readonly FormFieldDto[],
  answers: Record<string, unknown>,
): FormFieldDto[] {
  const result = buildFormAnswersSchema(fields).safeParse(answers)
  if (result.success) return []
  const failing = new Set(result.error.issues.map((issue) => String(issue.path[0])))
  return fields.filter((field) => failing.has(field.key))
}

/**
 * AC-373: the labels of the required fields a saved registration no longer
 * satisfies, or `[]` while either the form fields or the answers are unknown
 * (still loading, no form, no answers): never a false "needs update".
 */
export function incompleteRegistrationLabels(
  fields: readonly FormFieldDto[] | undefined,
  saved: { answers: Record<string, unknown> } | null | undefined,
): string[] {
  if (fields === undefined || saved === null || saved === undefined) return []
  return findIncompleteRegistrationFields(fields, saved.answers).map((field) => field.label)
}
